import { Output } from "valibot";

import {
  BaseIntegrationsSchema,
  BotInfoSchema,
} from "components/SonicBot/schemas";

import { generateIntegrationHandlers } from "./integrations/utils";
import { requestBackend } from "./request";

export enum WidgetPosition {
  left = "left",
  right = "right",
}

export enum ResponseLength {
  short = "short",
  medium = "medium",
  long = "long",
}

export interface BotPromptConfig {
  bot_id: string;
  generation_language: string;
}
export interface BotConfig {
  id: string;
  bot_info_config: Output<typeof BotInfoSchema>;
  bot_prompt_config: BotPromptConfig;
  vectorstore_index_id: string;
  api_token: string;
  system_prompt: string;
  updated_at: string;
  is_shared: boolean;
  user_form_visibility?: boolean;
}

// chat user form data
export interface ChatUserInputValue {
  key: string;
  value: string;
  id: string;
}

export interface ChatUserFormData {
  _id: string;
  created_at: string;
  data_values: ChatUserInputValue[];
}

export interface ChatGeneration {
  answer: string;
  chat_history: any;
}

export interface ChatInput {
  question: any;
  chat_history: any;
  token: string;
  service_base_URL: string;
  botId: string;
}

export interface GetBotSonicIntegrationsInput {
  botId: string;
}

export const getBotSonicIntegrations = async ({
  botId,
}: GetBotSonicIntegrationsInput) =>
  requestBackend(
    `/v1/botsonic/${botId}/third-party-integrations?isActive=true`,
    {
      schema: BaseIntegrationsSchema,
    },
  )
    .then(data => {
      return generateIntegrationHandlers(data);
    })
    .catch();

export const saveBotSonic = ({
  token,
  botId,
  chat_id,
  chat_history,
}: {
  token: string;
  botId: string;
  chat_id: string;
  chat_history: any;
}): Promise<any> =>
  requestBackend(`/v1/botsonic/history/save`, {
    method: "POST",
    headers: {
      token,
    },
    body: JSON.stringify({
      bot_id: botId,
      chat_id,
      chat_history,
    }),
    // eslint-disable-next-line no-console
  }).catch(err => console.error(err));

export const createUser = ({
  token,
  data,
}: {
  baseURL: string;
  token: string;
  data: ChatUserInputValue[];
}): Promise<ChatUserFormData> =>
  requestBackend(`/v1/botsonic/widget/chat-user-form-data`, {
    method: "post",
    headers: {
      token,
    },
    body: JSON.stringify({
      data_values: data,
    }),
  }) as any;

export const saveLikeDislike = ({
  token,
  chatId,
  messageId,
  likeStatus,
  isOverallChatFeedback = false,
  isResolved,
  additionalFeedback,
  chatEnded = false,
}: {
  token: string;
  chatId: string;
  messageId?: string;
  likeStatus?: string;
  isOverallChatFeedback?: boolean;
  isResolved?: boolean;
  additionalFeedback?: string;
  chatEnded?: boolean;
}): Promise<any> =>
  requestBackend(`/v1/botsonic/widget/like-dislike`, {
    method: "post",
    headers: {
      token,
    },
    body: JSON.stringify({
      chat_id: chatId,
      message_id: messageId,
      like_status: likeStatus,
      is_overall_chat_feedback: isOverallChatFeedback,
      is_resolved: isResolved,
      additional_feedback: additionalFeedback,
      chat_ended: chatEnded,
    }),
  });
interface IsummaryData {
  summary: string;
  subject: string;
}
export const getHumanHandoffSummary = async ({
  chatId,
  token,
}: {
  token: string;
  chatId: string;
}): Promise<IsummaryData | void> =>
  requestBackend(`/v1/bot-addon/human-handoff/${chatId}/summary`, {
    headers: {
      token,
    },
  })
    .then(data => {
      const summeryData = data as IsummaryData;
      return summeryData;
    })
    .catch();
interface ICreateTickert {
  name: string;
  email: string;
  summary: string;
  subject: string;
  token: string;
}
export const createTicketHandOff = async ({
  name,
  email,
  summary,
  subject,
  token,
}: ICreateTickert) =>
  requestBackend(`/v1/bot-addon/human-handoff/ticket`, {
    method: "POST",
    headers: {
      token,
    },
    body: JSON.stringify({
      name,
      email,
      summary,
      subject,
    }),
  })
    .then(data => {
      return data;
    })
    .catch();

export const requestCallback = ({
  token,
  chatUserFormDataId,
  chatId,
}: {
  token: string;
  chatUserFormDataId: string;
  chatId: string;
}): Promise<ChatUserFormData> =>
  requestBackend(`/v1/botsonic/widget/request-callback`, {
    method: "post",
    headers: {
      token,
    },
    body: JSON.stringify({
      chat_user_id: chatUserFormDataId,
      chat_history_id: chatId,
    }),
  }) as any;
